import { head, last } from 'lodash-es'
import { FC } from 'react'
import { I18N } from 'utils/localisation'

import { IShipTpEvent } from '../domain/TransportPlanEvent'
import { formatDatesRangeString } from '../service/format'
import {
  getTimestampRangeCtxValues,
  TpTimestampRangeCtx,
  TTpTimestampRangeCtx,
} from '../service/TpTimestampRangeContext'
import { getTpEventsSortedByDate } from '../service/transportPlanEventUtils'
import { TpRangeDifferentMonths } from './TpRangeDifferentMonths'
import { TpRangeSameMonth } from './TpRangeSameMonth'
import { TPTimestampSingle } from './TPTimestamp'

interface ITpEventTimestampRangeProps {
  events: IShipTpEvent[]
  useShortDate?: boolean
}
export const TpEventTimestampRange: FC<ITpEventTimestampRangeProps> = (props) => {
  const { events, useShortDate = false } = props
  const filteredEvents = events.filter((event) => !!event).filter((event) => !!event.aggregatedTimestamp)
  if (filteredEvents.length === 0) {
    // lcl after booking, for example
    return <I18N term="delivery_date-not_available" />
  }
  const sortedEvents = getTpEventsSortedByDate(filteredEvents)
  const furthestEvent = head(sortedEvents)
  const latestEvent = sortedEvents.length > 1 && last(sortedEvents)

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const isSame = !latestEvent || furthestEvent.aggregatedTimestamp.date === latestEvent.aggregatedTimestamp.date

  if (isSame) {
    const event = latestEvent || furthestEvent
    return (
      // @ts-expect-error TS(2322) FIXME: Type 'ITimestampJSON | undefined' is not assignabl... Remove this comment to see the full error message
      <TPTimestampSingle aggregatedTimestamp={event.aggregatedTimestamp} revisedTimestamp={event.revisedTimestamp} />
    )
  }

  const range = formatDatesRangeString(
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    latestEvent.aggregatedTimestamp.date,
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    furthestEvent.aggregatedTimestamp.date,
    useShortDate
  )

  if (range && typeof range === 'string') {
    return <TpRangeSameMonth range={range} events={events} />
  }

  return (
    <TpRangeDifferentMonths range={range as [string, string]} furthestEvent={furthestEvent} latestEvent={latestEvent} />
  )
}

type ITpEventTimestampRangeWithProviderProps = ITpEventTimestampRangeProps & Partial<TTpTimestampRangeCtx>

export const TpEventTimestampRangeWithProvider: FC<ITpEventTimestampRangeWithProviderProps> = (props) => {
  const { events, ...rest } = props
  const timestampRangeCtxValues = getTimestampRangeCtxValues(rest)
  return (
    <TpTimestampRangeCtx.Provider value={timestampRangeCtxValues}>
      <TpEventTimestampRange events={events} useShortDate={timestampRangeCtxValues.useShortDate} />
    </TpTimestampRangeCtx.Provider>
  )
}
